export default function ({ store }) {
  store.dispatch('header/closeMenu')
}
